import { render, staticRenderFns } from "./SignDocumentDetailViewer.vue?vue&type=template&id=61fc62ca&scoped=true&"
import script from "./SignDocumentDetailViewer.vue?vue&type=script&lang=ts&"
export * from "./SignDocumentDetailViewer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61fc62ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
